import { Component } from '@angular/core';
import { BazaRegistryNgService } from '@scaliolabs/baza-core-ng';

@Component({
    selector: 'app-footer-mini',
    templateUrl: './footer-mini.component.html',
    styleUrls: ['./footer-mini.component.less'],
})
export class FooterMiniComponent {
    today = new Date();

    constructor(private readonly registry: BazaRegistryNgService) {}

    public getServiceLink(link): string {
        return this.registry.value(link);
    }
}
